import styled, { css } from "styled-components";

import installImage from "assets/install.svg";
import { media } from "components/styles/breakpoints";
import { COLORS } from "utils/constants";
import { screenItemMixin } from "./DataScreenBase";

// LIST

export const ItemsListWrapper = styled.div``;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${media.desktop`
    gap: 15px;
  `}
`;

export const EmptyList = styled.div`
  text-align: center;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  ${screenItemMixin}

  ${media.desktop`
    font-size: 18px;
  `}
`;

// ITEM

export const ActionWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000090;
  opacity: 0;
  transition: opacity 200ms ease-out;
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
`;

export const ItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const restrictedMixin = css`
  opacity: 0.4;
`;

const installedMixin = css<{ partColor: string }>`
  box-shadow: 0 0 0 1px ${({ partColor }) => partColor};
`;

export const ItemImageWrapper = styled.div<{
  isInstalled: boolean;
  isRestricted: boolean;
  partColor: string;
}>`
  width: 32px;
  height: 32px;
  position: relative;
  flex-shrink: 0;
  border-radius: 4px;

  ${({ isRestricted }) => isRestricted && restrictedMixin}
  ${({ isInstalled }) => isInstalled && installedMixin}
  
  ${media.desktop`
    width: 44px;
    height: 44px;
  `}
`;

export const ItemInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ItemTitle = styled.div<{ isRestricted?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;

  ${({ isRestricted }) => isRestricted && restrictedMixin}

  ${media.desktop`
    font-size: 18px;
  `}
`;

export const ItemInstalled = styled.div<{ partColor: string }>`
  font-size: 24px;
  cursor: pointer;
  color: ${({ partColor }) => partColor};
`;

export const ItemRestricted = styled.div`
  font-size: 20px;
  cursor: pointer;
  color: ${COLORS.RESTRICTED};
`;

export const Description = styled.div`
  font-size: 10px;

  ${media.desktop`
    font-size: 14px;
  `}
`;

export const ItemText = styled.div<{ color: string; colorSecondary?: string }>`
  background: linear-gradient(
    to right,
    ${({ color }) => color} 0%,
    ${({ colorSecondary, color }) => colorSecondary || color} 100%
  );
  width: fit-content;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const ItemQuantity = styled.div`
  font-size: 12px;
  text-align: right;

  ${media.desktop`
    font-size: 16px;
  `}
`;

// ITEM ACTIONS

export const ItemActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ItemButtons = styled.div`
  display: flex;
  gap: 5px;
  align-items: stretch;
`;

export const InventoryActionIcon = styled.div`
  mask: url(${installImage}) no-repeat center;
  width: 12px;
  height: 12px;
  background-color: white;
  aspect-ratio: 1/1;
`;
